import { useEffect, useState } from 'react';

/**
 * Suppresses the loader on fast requests without delaying results
 */
export function useDelayedFlag(active: boolean, delayMs = 250): boolean {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!active) {
      setDelayed(false);
      return;
    }
    const timeoutId = setTimeout(() => setDelayed(true), delayMs);
    return () => clearTimeout(timeoutId);
  }, [active, delayMs]);

  return delayed;
}
